<template>
	<div class="footer">

		<ul class="menu_bottom">
			<li></li>
			<li>
				<div class="category desktop"> About Us </div>
				<br class="hide_break">
				<span>凝靜美學有限公司<br> 台北市</span>
				106
				<span>大安區信義路四段</span>6<span>號</span>14<span>樓</span>-6<br>
				14F.-6, No.6, Sec. 4, Sinyi Rd., Da’an Dist., Taipei City 106, Taiwan<br>
				<br>
				Office (14F.-6): +886-2-2706-8016<br>
				Salon (11F.-6): +886-2-2706-8086<br>
				Mobile: +886-966-007-670
			</li>
			<li>
				<div class="category"> Follow Us on Social Media </div>
				<br><br class="hide_break">

				<a href="https://www.facebook.com/serene.tpe/?ref=page_internal">
					<font-awesome-icon class="icon" :icon="['fab', 'facebook-square']" />
				</a>
				<a href="https://www.instagram.com/serene.tpe/?hl=en">
					<font-awesome-icon class="icon" :icon="['fab', 'instagram']" />
				</a>
				<a href="https://line.me/R/ti/p/%40tho9283q">
					<font-awesome-icon class="icon" :icon="['fab', 'line']" />
				</a>

			</li>
			<li>
				<div class="category"> Send us an Email!  </div>
				<br><br class="hide_break">
				<font-awesome-icon class="icon" :icon="['fas', 'envelope']" />
				serene.tpe@gmail.com
			</li>
		</ul>

		<div class="visitorCount">
          Visitor Count: {{ this.visitorCount }} <br>
		</div>

	</div>
</template>

<script>
import Styles from "./styles.scss"

export default{
	name: "Footer", 
	data(){
		return {
          visitorCount: "-",
          Styles
		};
	},
	mounted() {
      fetch('https://serene-logs.herokuapp.com/visit')
        .then(response => response.json())
        .then(data => {
          this.visitorCount = data.visitor_count;
        })
        .catch(error => console.error(error));
	}
};
</script>
